import { render, staticRenderFns } from "./LgFinderPessoa.vue?vue&type=template&id=00e42330"
import script from "./LgFinderPessoa.vue?vue&type=script&lang=js"
export * from "./LgFinderPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports